import React from 'react';
import { Clock } from 'lucide-react';
import { COMPANY } from '../../../data/constants';

// LoadingScreen
// Params:
// - size: 'full' | 'overlay' | 'inline'
// - message: string
// - showProgress: boolean
// - progress: number 0..100
export const LoadingScreen = ({
  showProgress = false,
  progress = 0,
  size = 'full',
  message = 'Please wait while we prepare everything for you',
}) => {

  const getIcon = () => {
    return <Clock className="h-12 w-12 text-primary-600" />;
  };

  const containerClasses = {
    full: 'fixed inset-0 z-50 flex items-center justify-center bg-white',
    overlay: 'absolute inset-0 z-40 flex items-center justify-center bg-white bg-opacity-90 backdrop-blur-sm',
    inline: 'flex items-center justify-center p-8'
  };

  return (
    <div className={containerClasses[size]}>
      <div className="flex flex-col items-center justify-center text-center w-full">
        <div className="flex items-center justify-center mb-2 w-full">{getIcon()}</div>

        {/* Website Name */}
        <h1 className="text-2xl font-bold text-gray-900 mb-8">{COMPANY.name}</h1>

        {showProgress ? (
          <div className="w-64 mx-auto mb-4">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-primary-600 h-2 rounded-full transition-all duration-300 ease-out"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="text-sm text-gray-600 mt-2">{Math.round(progress)}%</div>
          </div>
        ) : (
          <div className="w-64 mx-auto mb-4">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div className="bg-primary-600 h-2 rounded-full animate-pulse"></div>
            </div>
          </div>
        )}

        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

